import { Box } from "@mui/material";
import { isNil } from "lodash";
import { useMemo } from "react";
import Htag from "../typography/Htag";
import Flx from "./Flx";
import ScreenContent from "./ScreenContent";
import Txt from "../typography/Txt";

const TitledHeader = ({
  children,
  variant = "h2",
  sx,
  title,
  titleBottomContent,
  titleTopContent,
  titleContent,
  titleEndContent,
  titleStartContent,
  titleComponent,
  endContent,
  hideBottomBorder,
  description,
}) => {
  const styles = useMemo(() => {
    return {
      display: "flex",
      background: "#ffffff",
      flexDirection: "column",
      borderBottom: hideBottomBorder ? "none" : "1px solid #e0e0e0",
      ...sx,
    };
  }, [sx, hideBottomBorder]);
  return (
    <>
      <ScreenContent sx={styles}>
        <Flx wrap gap={2} fw jb ac>
          <TitleContent
            title={title}
            titleBottomContent={titleBottomContent}
            titleTopContent={titleTopContent}
            titleContent={titleContent}
            titleEndContent={titleEndContent}
            titleStartContent={titleStartContent}
            titleComponent={titleComponent}
            variant={variant}
            description={description}
          />
          {endContent}
        </Flx>
        {isNil(children) ? null : <Box>{children}</Box>}
      </ScreenContent>
    </>
  );
};

const TitleContent = ({
  titleStartContent,
  titleEndContent,
  variant,
  title,
  titleComponent,
  titleTopContent,
  titleBottomContent,
  titleContent,
  description,
}) => {
  if (titleContent) {
    return titleContent;
  }

  // if (titleStartContent || titleEndContent) {
  //   return (
  //     <Flx ac gap={1}>
  //       {titleStartContent}
  //       <Title variant={variant}>{title}</Title>
  //       {titleEndContent}
  //     </Flx>
  //   );
  // }

  if (
    titleTopContent ||
    titleBottomContent ||
    titleStartContent ||
    titleEndContent ||
    description
  ) {
    return (
      <Flx column gap={0.4}>
        {titleTopContent}
        <Flx ac gap={1}>
          {titleStartContent}
          <Title titleComponent={titleComponent} variant={variant}>
            {title}
          </Title>
          {titleEndContent}
        </Flx>
        {description ? <Txt secondary>{description}</Txt> : null}
        {titleBottomContent}
      </Flx>
    );
  }
  return (
    <Title titleComponent={titleComponent} variant={variant}>
      {title}
    </Title>
  );
};
const Title = ({ variant, children, titleComponent }) => {
  if (titleComponent) {
    return titleComponent;
  }
  return <Htag variant={variant}>{children}</Htag>;
};
export default TitledHeader;
